<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell" slot="mm_title">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mm_title || "会议议题"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.mm_title"
              placeholder="请填写"
            />
          </div>
        </div>
        <date-field
          slot="mm_date"
          :label="customLabel.mm_date || '会议日期'"
          v-model="form.main.mm_date"
        />
        <time-field
          slot="mm_start"
          :label="customLabel.mm_start || '开始时间'"
          v-model="form.main.mm_start"
        />
        <time-field
          slot="mm_over"
          :label="customLabel.mm_over || '结束时间'"
          v-model="form.main.mm_over"
        />
        <meeting-field
          slot="mm_mrname"
          :label="customLabel.mm_mrname || '会议室'"
          v-model="form.main.mm_mrname"
          @select="onSelectMeeting"
        />

        <div class="weui-cell" slot="mm_address">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mm_address || "地点"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <p>{{ form.main.mm_address }}</p>
          </div>
        </div>
        <account-check-box
          :label="'参会人员'"
          slot="mm_emnames"
          v-model="form.main.mm_emnames"
          @select="onSelectCcrecipients"
        />
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="mm_remind"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mm_remind || "提醒设置"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.mm_remind"
              placeholder="请选择"
            >
              <option value="0">会议开始前</option>
              <option value="5">5分钟前</option>
              <option value="15">15分钟前</option>
              <option value="30">30分钟前</option>
              <option value="60">1小时前</option>
              <option value="1440">1天前</option>
            </select>
          </div>
        </div>
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="mm_repeat"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mm_repeat || "重复"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.mm_repeat"
              placeholder="请选择"
            >
              <option>每天重复</option>
              <option>每周重复</option>
              <option>每两周重复</option>
              <option>每月重复</option>
            </select>
          </div>
        </div>
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="mm_weekday"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mm_weekday || "工作日"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.mm_weekday"
              placeholder="请选择"
            >
              <option value="true">是</option>
              <option value="false">否</option>
            </select>
          </div>
        </div>
        <div
          class="weui-cell weui-cell_active weui-cell_switch"
          slot="mm_status"
        >
          <div class="weui-cell__bd">
            {{ customLabel.mm_status || "启用状态" }}
          </div>
          <div class="weui-cell__ft">
            <input
              class="weui-switch"
              v-model="form.main.mm_status"
              type="checkbox"
              v-bind:true-value="1"
              v-bind:false-value="0"
            />
          </div>
        </div>
      </custom-layout>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DateField from "@/components/field/DateField.vue";
import TimeField from "@/components/field/TimeField.vue";
import AccountCheckBox from "@/components/field/AccountCheckBox.vue";
import MeetingField from "@/components/field/MeetingField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    DateField,
    AccountCheckBox,
    MeetingField,
    TimeField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/meetingmodel",
      codeField: "mm_code",
      caller: "MeetingModel",
      xtype: "oa-meetingmodel-formpanel",
      form: {
        main: {
          mm_emnames: null,
          mm_emids: null,
          mm_date: null,
          mm_address: null,
          mm_mrname: null,
          mm_remind: "5",
          mm_title: null,
          mm_start: null,
          mm_over: null,
        },
      },
    };
  },
  methods: {
    onSelectCcrecipients(selection) {
      let main = this.form.main;
      (main.mm_emnames = selection.map((item) => item.em_name).join(",")),
        (main.mm_emids = selection.map((item) => item.id).join(","));
    },
    onSelectMeeting(item) {
      let main = this.form.main;
      main.mm_mrname = item.mr_name;
      main.mm_address = item.mr_address;
    },
    save() {
      var me = this,
        main = me.form.main;
      if (!main.mm_title) {
        me.$weui.topTips("请输入会议议题", 2000);
      } else if (!main.mm_mrname) {
        me.$weui.topTips("请选择会议室", 2000);
      } else if (!main.mm_date) {
        me.$weui.topTips("请选择会议日期", 2000);
      } else if (!main.mm_start) {
        me.$weui.topTips("请选择开始时间", 2000);
      } else if (!main.mm_over) {
        me.$weui.topTips("请选择结束时间", 2000);
      } else if (!main.mm_remind) {
        me.$weui.topTips("请选择提醒设置", 2000);
      } else {
        me.p_save();
      }
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}
</style>